import { MuiBox, MuiTypography } from "../../../../components";
import { TaxDetailsTableHeaderWrapper } from "./TaxDetailsTableHeader.style";

export const TaxDetailsTableHeader: React.FC<{
  header: string;
}> = ({ header }) => {
  return (
    <TaxDetailsTableHeaderWrapper>
      <MuiBox>
        <MuiTypography variant="h2SemiBold">{header}</MuiTypography>
      </MuiBox>
    </TaxDetailsTableHeaderWrapper>
  );
};
